import { Data, Part } from 'clarifai-web-grpc/proto/clarifai/api/resources_pb';
import { JavaScriptValue, Struct } from 'google-protobuf/google/protobuf/struct_pb';
import { setPartDataTypes } from 'modules/Models/components/ModelForm/utils/setPartDataTypes';
import { ApiModelTypeField } from 'types/swagger/clarifai-api';

export const constructPartsFromParams = (params: Record<string, JavaScriptValue>, modelParamSpecs?: ApiModelTypeField[]) => {
  const paramsStruct = Struct.fromJavaScript(params).toObject();
  const newParts = Object.entries(paramsStruct.fieldsMap).map(([, [fieldName, fieldValue]]) => {
    const part = new Part();
    const data = new Data();
    part.setData(data);
    part.setId(fieldName);

    const fieldType = modelParamSpecs?.find((spec) => spec.name === fieldName)?.type;

    // unknown type conversion needed since the enum gives the index number in API
    setPartDataTypes(data, fieldValue, fieldType as unknown as number);
    return part;
  });
  return newParts;
};
